/**
 * Created by JIocb on 13.05.2017.
 */
namespace Factive.Game {
        export enum DiceColorType
        {
            Red,
            Green,
            Yellow,
            Siren,
            Orange,
            Blue
        }

}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/Model/Dice/DiceColorType.ts